import React from "react";
import { Link, useLocation } from "react-router-dom";
import { canonicalPath, metaForPath } from "../../seo/seo";
import "./Breadcrumbs.css";

export default function Breadcrumbs({ metaByPath = {} }) {
  const { pathname } = useLocation();
  const path = canonicalPath(pathname);
  const meta = metaByPath[path] || metaForPath(path);
  const items = meta.breadcrumbs || [];

  if (items.length < 2 || meta.robots === "noindex, nofollow") return null;

  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb">
      <ol>
        {items.map((item, index) => {
          const isCurrent = index === items.length - 1;
          return (
            <li key={`${item.path}-${index}`}>
              {isCurrent ? (
                <span aria-current="page">{item.name}</span>
              ) : (
                <Link to={item.path}>{item.name}</Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
